export default "__VITE_ASSET__2290b312__"